/* Tsukuyomi custom behaviour - "Easy buying upgrade" (Oct 2026).
   1) Opens the cart drawer right after something is added to the cart.
   2) Phone cases: the shopper must pick an iPhone model before Add to cart / Buy now
      (on the product page and in the quick add pop-up on collection pages).
   3) Tells the page which model was picked, so the gallery shows that model's photo. */
(function () {
  'use strict';

  /* ---------- 1. Open the cart drawer after add to cart ---------- */
  document.addEventListener('cart:update', function (event) {
    var data = (event && event.detail && event.detail.data) || {};
    if (data.didError) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) return; /* already open (e.g. quantity change inside the cart) */
    drawer.open();
  });

  /* ---------- 2. "Select your iPhone" guard ---------- */
  var MODEL_SELECT = '[data-tsu-model-select] select';
  var BUY_SELECTOR = '.add-to-cart-button, .button-buy-now, shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button, button[name="add"]';

  /* Where to look for the model dropdown that belongs to this button / form */
  function scopeOf(el) {
    var quickAdd = el.closest('quick-add-dialog');
    if (quickAdd) return quickAdd;
    if (el.closest('product-card, dialog')) return null; /* other products / cart drawer */
    return document.getElementById('MainContent') || document;
  }

  function modelSelectIn(scope) {
    if (!scope) return null;
    var selects = scope.querySelectorAll(MODEL_SELECT);
    for (var i = 0; i < selects.length; i++) {
      if (scope.tagName === 'QUICK-ADD-DIALOG' || !selects[i].closest('quick-add-dialog')) return selects[i];
    }
    return null;
  }

  function needsModel(select) {
    if (!select) return false;
    var opt = select.options[select.selectedIndex];
    return !opt || opt.hasAttribute('data-tsu-placeholder');
  }

  function nudge(select) {
    var wrap = select.closest('[data-tsu-model-select]');
    if (!wrap) return;
    wrap.classList.remove('tsu-model-select--nudge');
    void wrap.offsetWidth;
    wrap.classList.add('tsu-model-select--nudge');
    var hint = wrap.querySelector('[data-tsu-model-hint]');
    if (hint) hint.hidden = false;
    wrap.scrollIntoView({ block: 'center' });
    try {
      select.focus({ preventScroll: true });
      if (typeof select.showPicker === 'function') select.showPicker();
    } catch (e) { /* showPicker is optional */ }
  }

  function guard(event, el) {
    var select = modelSelectIn(scopeOf(el));
    if (!needsModel(select)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    nudge(select);
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var btn = target.closest(BUY_SELECTOR);
    if (btn) guard(event, btn);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="id"]')) return;
    guard(event, form);
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLSelectElement) || !target.matches(MODEL_SELECT)) return;
    var wrap = target.closest('[data-tsu-model-select]');
    if (wrap) {
      wrap.classList.remove('tsu-model-select--nudge', 'tsu-model-select--empty');
      var hint = wrap.querySelector('[data-tsu-model-hint]');
      if (hint) hint.hidden = true;
    }
    var quickAdd = target.closest('quick-add-dialog');
    var picker = target.closest('variant-picker');
    if (quickAdd && picker) quickAdd.dataset.tsuChosenFor = picker.dataset.productUrl || 'yes';
  });

  /* Quick add pop-up: always start on "Select your iPhone" (product cards link to a default model) */
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function resetQuickAddSelects() {
    if (!seen) return;
    var selects = document.querySelectorAll('quick-add-dialog ' + MODEL_SELECT);
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (seen.has(select)) continue;
      seen.add(select);
      var quickAdd = select.closest('quick-add-dialog');
      var picker = select.closest('variant-picker');
      var url = picker ? picker.dataset.productUrl || 'yes' : 'yes';
      if (quickAdd && quickAdd.dataset.tsuChosenFor === url) continue;
      var placeholder = select.querySelector('[data-tsu-placeholder]');
      if (!placeholder) continue;
      for (var j = 0; j < select.options.length; j++) select.options[j].removeAttribute('selected');
      placeholder.setAttribute('selected', 'selected');
      select.selectedIndex = 0;
      var wrap = select.closest('[data-tsu-model-select]');
      if (wrap) wrap.classList.add('tsu-model-select--empty');
    }
  }

  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; resetQuickAddSelects(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('close', function (event) {
    var quickAdd = event.target instanceof Element ? event.target.closest('quick-add-dialog') : null;
    if (quickAdd) delete quickAdd.dataset.tsuChosenFor;
  }, true);

  /* ---------- 3. Send ?variant= with the variant update request ---------- */
  if (window.customElements) {
    customElements.whenDefined('variant-picker').then(function () {
      var VP = customElements.get('variant-picker');
      if (!VP || VP.prototype.__tsuPatched) return;
      var original = VP.prototype.buildRequestUrl;
      if (typeof original !== 'function') return;
      VP.prototype.buildRequestUrl = function (selectedOption) {
        var url = original.apply(this, arguments);
        try {
          var variantId = selectedOption && selectedOption.dataset ? selectedOption.dataset.variantId : '';
          if (variantId && this.querySelector('[data-tsu-model-select]')) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
          }
        } catch (e) { /* keep the original URL */ }
        return url;
      };
      VP.prototype.__tsuPatched = true;
    });
  }
})();